import styled from 'styled-components';
import theme from '../../../styles/defaultTheme';

export const Container = styled.div`
  display: flex;
  cursor: pointer;
  margin-right: ${theme.margin.x5};
`;

export const Count = styled.span`
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -9px;
  margin-left: -9px;
  border-radius: 50%;
  user-select: none;
  background: ${(props) => props.theme.orangeLink};

  font-size: ${theme.font.size12};
  font-weight: bold;
  line-height: 24px;
  color: ${(props) => props.theme.white};
`;

export const DropdownContentContainer = styled.div`
  width: 100%;
  height: 100%;
  max-width: 400px;
  max-height: 400px;
  overflow: auto;
  padding: ${theme.padding.x2} ${theme.padding.x3};
  border: 1px solid ${(props) => props.theme.grey20};
  border-radius: ${theme.border.radius.modal};
  box-shadow: 0px 6px 8px #00000014;
  background: ${(props) => props.theme.white};
`;

export const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;

  font: ${theme.font.h6};
  color: ${(props) => props.theme.black};

  .material-icon {
    cursor: pointer;
  }
`;

export const UnorderedList = styled.ul`
  margin: ${theme.margin.x2} 0 0;
  padding: 0;
  list-style: none;
`;

export const List = styled.li`
  padding: ${theme.padding.x2} 0;
`;

export const Anchor = styled.a`
  display: block;

  font: ${theme.font.body[6]};
  line-height: 21px;
  color: ${(props) => props.theme.blackLink40} !important;
`;

export const ContainerTitle = styled.div`
  display: flex;
  margin-bottom: 4px;

  font: ${theme.font.subtitle};
  color: ${(props) => props.theme.blackLink};
`;

export const Dot = styled.div`
  width: 100%;
  max-width: 10px;
  height: 10px;
  margin: 4px ${theme.margin.x1} 0 0;
  border-radius: 50%;
  background-color: ${(props) => props.theme.orangeLink}
`;
